import { FC } from 'react';

import { AppName } from './title.styles';

const Title: FC = () => (
  <AppName>
    <span>spli</span>
    <span>tter</span>
  </AppName>
);

export default Title;
